<template>
    <div class="lang-buttons">
        <coddin-button pName="NL" @codd_input="onClick('nl')"/>
        <coddin-button pName="EN" @codd_input="onClick('en')"/>
        <coddin-button pName="DE" @codd_input="onClick('de')"/>
    </div>
</template>

<script>
  import CoddinButton from "../../input/Button";
  import {mapMutations} from "vuex";

  export default {
    name: 'MenuItemLanguageButtons',
    components: {
      CoddinButton
    },
    methods: {
      ...mapMutations('preference', [
        'setLocale',
      ]),
      onClick(val) {
        this.setLocale(val)
      }
    }
  }
</script>

<style scoped lang="scss">
 .lang-buttons {
        display: flex;
     background-color: #dee;
 }
</style>